<svg width="0" height="0" style="position: absolute;">
  <defs>
    <clipPath id="shape-mask" clipPathUnits="objectBoundingBox">
      <path d="M0.077,0 H0.923 C0.965,0 1,0.035 1,0.077 V0.78 C1,0.822 0.965,0.857 0.923,0.857 H0.78 C0.738,0.857 0.703,0.892 0.703,0.934 V0.923 C0.703,0.965 0.668,1 0.626,1 H0.077 C0.035,1 0,0.965 0,0.923 V0.077 C0,0.035 0.035,0 0.077,0 Z" />
    </clipPath>
  </defs>
</svg>

<main class="flex min-h-screen items-center justify-between bg-gradient-to-r from-lBlack to-lBlue700 px-4">
  <section class="flex w-full flex-col items-center justify-center lg:max-w-[40%]">
    <img class="mx-auto mb-5" src="assets/images/unico-logo.svg" alt="uni:co." width="130" />

    <div class="space-y-2 text-center">
      <h1 class="text-2xl font-semibold text-lWhite">Esqueceu a senha</h1>
      <p class="text-sm text-lSecondary">Informe seu e-mail para receber as instruções de recuperação</p>
    </div>

    <form
      class="mx-auto mt-8 w-full animate-fadeIn lg:max-w-[30rem]"
      [formGroup]="form"
      (submit)="submit()"
      autocomplete="off"
    >
      <div class="space-y-6">
        <div class="space-y-2">
          <label class="text-sm font-medium text-lSecondary" for="email">E-mail</label>
          <div class="form-input relative flex items-center">
            <l-icon class="form-input--icon">alternate_email</l-icon>
            <input
              type="email"
              id="email"
              placeholder="exemplo@email.com"
              formControlName="email"
              autocomplete="off"
            />
          </div>
        </div>

        <button
          lButton
          type="submit"
          [disabled]="isDisabled"
          [bType]="isDisabled ? buttonTypes.OUTLINE : buttonTypes.PRIMARY"
          [bRadius]="buttonRadius.LARGE"
        >
          @if (isLoading) {
            <l-spinner [size]="spinnerSize.SMALL" [color]="spinnerColors.WHITE" />
          }
          <span>Confirmar</span>
        </button>

        <a
          routerLink="/login"
          class="block text-center text-sm text-lSecondary transition-colors hover:text-lWhite"
        >
          Voltar
        </a>
      </div>
    </form>
  </section>

  <aside class="hidden h-screen flex-1 items-center justify-center lg:flex">
    <div class="relative h-[95%] w-[95%]">
      <div class="shape-card h-full w-full"></div>

      <l-animated-banner class="pointer-events-none absolute inset-0 z-10" />

      <div class="gradient-border absolute bottom-[20%] left-[5%] z-20 lg:bottom-[25%] lg:left-[10%] xl:bottom-[30%]">
        <span class="text-sm font-semibold text-lWhite lg:text-base xl:text-lg 2xl:text-xl">Educação Corporativa</span>
      </div>
      <div class="gradient-border absolute bottom-[10%] left-0 z-20 lg:bottom-[15%] xl:bottom-[20%]">
        <span class="text-sm font-semibold text-lWhite lg:text-base xl:text-lg 2xl:text-xl">Treinamentos e workshops</span>
      </div>

      <img src="assets/images/unico-logo.svg" alt="uni:co." class="absolute bottom-[5%] right-[7%] z-10 w-[15%] min-w-28" />
    </div>
  </aside>
</main>
